import React from 'react';
import PropTypes from 'prop-types';
import i52 from 'assets/images/i52.png';
import { Fade } from 'components/Animations';

const Lighthouse = ({ title, text }) => (
  <Fade in={true} appear={true} className="noresults">
    <div className="noresults-icon"><img src={i52} alt="" /></div>
    <div className="noresults-message">
      <h3>{title}</h3>
      <div>{text}</div>
    </div>
  </Fade>
);

Lighthouse.propTypes = {
  title: PropTypes.any.isRequired,
  text: PropTypes.any.isRequired,
};

export default Lighthouse;


// WEBPACK FOOTER //
// ./src/components/ui/Lighthouse.jsx